<template>
  <SocioBtn
    prepend-icon="mdi-plus"
    text="Incertitude"
    rounded
    :size="mdAndDown ? 'medium' : 'large'"
    class="btn"
    data-testid="incertitude-button"
    @click="openDialog"
  />
  <IncertitudeModal v-if="modelValue" v-model="modelValue" data-testid="incertitude-modal" />
</template>
<script setup>
import { ref } from "vue";
import { useDisplay } from "vuetify";
import IncertitudeModal from "@/components/ssp/missions/mission/mission-global-synthesis/IncertitudeModal.vue";

const modelValue = ref(false);
const { mdAndDown } = useDisplay();
const openDialog = () => {
  modelValue.value = true;
};
</script>
<style lang="scss" scoped>
.btn {
  position: fixed;
  bottom: 10px;
  left: 280px;
  z-index: 5;
}
@media (max-width: 1060px) {
  .btn {
    left: 60px;
  }
}
@media (max-width: 600px) {
  .btn {
    left: 20px;
  }
}
</style>
